// extracted by mini-css-extract-plugin
var _1 = "jrTk5";
var _2 = "smKz9";
var _3 = "nhedf elide";
var _4 = "kuVXL";
export { _1 as "body", _2 as "item", _3 as "name", _4 as "typeIcon" }
